import { FunctionComponent } from "react";
import { Modal, ModalContent, ModalTitle } from "@ui-kit/Modal/Modal";
import { useTranslation } from "react-i18next";
import "./ShareEntity.css";
// import { ShareEmail } from "./ShareEmail";
// import { ShareSms } from "./ShareSms";

interface ShareEntityModalProps {
  view: "sms" | "email";
  isOpen: boolean;
  onClose: () => void;
}

const ShareEntityModal: FunctionComponent<ShareEntityModalProps> = ({
  view,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal open={isOpen} onClose={onClose} width={390} segmentedFooter={true}>
        <ModalTitle>
          <div className="share-entity-title-container">
            {view === "sms" && t("share.entity.smsTitle")}
            {view === "email" && t("share.entity.emailTitle")}
          </div>
        </ModalTitle>
        <ModalContent>
          <div className="share-entity-content">
            {/* {view === "sms" && <ShareSms onClose={onClose} />}
            {view === "email" && <ShareEmail onClose={onClose} />} */}
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export { ShareEntityModal };
